import React, { useState } from "react";
import logo from "../../src/assets/logo.svg"
import { Layout, Menu, Drawer, Button } from "antd";
import "./Header.css";


const { Header } = Layout;


const Headers = ({ scrollToHome, scrollToFeatures, scrollToContact, scrollToTestimonial }) => {

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showNavbar, setShowNavbar] = useState(false);

    const toggleNavbar = () => {
        setShowNavbar(!showNavbar);
    };

    const handleMenuItemClick = (onClick) => {
        if (onClick) onClick();
        setShowNavbar(false);
    };

    // Toggle menu state
    const toggleMenu = () => {
      setIsMenuOpen(!isMenuOpen);
    };

    const [selectedKey, setSelectedKey] = useState(["1"]);

    const menuItems = [
        { key: '1', label: 'Home', onClick: scrollToHome },
        { key: '2', label: 'Features', onClick: scrollToFeatures },
        { key: '3', label: 'Testimonials', onClick: scrollToTestimonial },
        { key: '4', label: 'Contact', onClick: scrollToContact },
    ];

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);


    return (
        <Layout className=" " style={{ backgroundColor: "#0A160D80" }} >
            {/* Desktop Header */}
            <Header className=" header-bar desktop-header ">

                <div className="header-title">

                    <div className="ownheader" style={{ display: "flex", alignItems: "center", gap: "1rem", cursor: "pointer" }} onClick={scrollToHome} >
                        <img
                            src={logo}
                            alt="QuranLogo"
                            style={{}}
                        />
                        <h6 style={{ fontSize: "20px", fontWeight: "700", color: 'white', position: "relative", top: "5px" }}>Quran Point</h6>
                    </div>


                    <Menu
                        mode="horizontal"
                        className="header-menu"
                        selectedKeys={selectedKey}
                        onClick={(e) => setSelectedKey([e.key])}
                        disabledOverflow
                    >
                        {menuItems.map(item => (
                          
                            <Menu.Item key={item.key} onClick={item.onClick}>
                                {item.label}
                            </Menu.Item>
                        ))}
                    </Menu>
                </div>

            </Header>

            {/* Mobile/Tablet Header */}
            <Header className="mobile-header header-bar">
                <div className="header-title-mobile">
                    <div className="logo-wrapper" onClick={scrollToHome}>
                        <img src={logo} alt="QuranLogo" />
                        <h6 className="logo-text" style={{ color: "#ffff", position: "relative", top: "7px" }}>Quran Point</h6>
                    </div>
                   
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg" onClick={toggleNavbar} >
                        <rect y="4" width="24" height="2" rx="1" fill="white" />
                        <rect y="11" width="24" height="2" rx="1" fill="white" />
                        <rect y="18" width="24" height="2" rx="1" fill="white" />
                    </svg>

                </div>

                <div className ={ ` mobile-menu-items  ${showNavbar ? 'slide-in-navbar' : 'slide-out-navbar'}` } >
                    {menuItems.map(item => (
                        <div
                            key={item.key}
                            className="mobile-menu-link"
                            onClick={() => handleMenuItemClick(item.onClick)}
                        >
                            {item.label}
                        </div>
                    ))}
                </div>
            </Header>

        </Layout>
    );
};

export default Headers;
